export default {
  admin_add_cad_user_swal_required_title: "Campos obligatorios",
  admin_add_cad_user_swal_required_text_name_email: "Complete Nombre y E-mail para continuar.",
  admin_add_cad_user_swal_required_text_phone: "Complete el Teléfono para continuar.",
  admin_add_cad_user_swal_required_cnpj_title: "CNPJ obligatorio",
  admin_add_cad_user_swal_required_cnpj_text: "Para crear un cliente es necesario informar el CNPJ.",
  admin_add_cad_user_swal_success_client_title: "¡Cliente creado!",
  admin_add_cad_user_swal_success_client_text: "El cliente fue registrado con éxito",
  admin_add_cad_user_swal_success_employee_title: "¡Empleado registrado!",
  admin_add_cad_user_swal_success_employee_text: "El empleado fue registrado con éxito.",
  admin_add_cad_user_swal_error_title: "Error",
  admin_add_cad_user_swal_error_text: "No fue posible crear el usuario. Inténtelo de nuevo.",
  admin_add_cad_user_title: "Crear usuario",
  admin_add_cad_user_label_name: "Nombre:",
  admin_add_cad_user_placeholder_name: "Maria Silva",
  admin_add_cad_user_label_email: "E-mail:",
  admin_add_cad_user_placeholder_email: "email@empresa.com",
  admin_add_cad_user_label_profile: "Perfil:",
  admin_add_cad_user_option_client: "Cliente",
  admin_add_cad_user_option_technician: "Técnico",
  admin_add_cad_user_option_admin: "Comercial",
  admin_add_cad_user_label_company: "Nombre de la empresa:",
  admin_add_cad_user_placeholder_company: "Empresa XYZ",
  admin_add_cad_user_label_cnpj: "CNPJ/CIF:",
  admin_add_cad_user_placeholder_cnpj: "00.000.000/0000-00",
  admin_add_cad_user_label_phone: "Teléfono:",
  admin_add_cad_user_placeholder_phone: "(11) 90000-0000",
  admin_add_cad_user_btn_create: "Crear",
  admin_add_cad_user_notify_text_1: "Su cliente será notificado vía e‑mail y WhatsApp con un link de acceso.",
  admin_add_cad_user_notify_text_2: "Durante la versión de prueba, cualquier usuario registrado tendrá la contraseña predeterminada \"123456\".",
  admin_add_equip_swal_attention_title: "Atención",
  admin_add_equip_swal_remove_warning_text: "Este equipo se eliminará al guardar.",
  admin_add_equip_swal_error_title: "Error",
  admin_add_equip_swal_invalid_service_text: "Seleccione un servicio válido.",
  admin_add_equip_swal_success_title: "Éxito",
  admin_add_equip_swal_save_success_text: "¡Equipo guardado!",
  admin_add_equip_swal_save_first_text: "Guarda el equipo primero.",
  admin_add_equip_swal_remove_photo_title: "¿Eliminar foto?",
  admin_add_equip_swal_remove_photo_success_text: "¡Foto eliminada!",
  admin_add_equip_prompt_laudo_name: "Nombre del informe:",
  admin_add_equip_swal_remove_laudo_title: "¿Eliminar informe?",
  admin_add_equip_swal_remove_laudo_success_text: "Informe eliminado.",
  admin_add_equip_label_service: "Servicio vinculado",
  admin_add_equip_label_brand: "Marca",
  admin_add_equip_label_model: "Modelo",
  admin_add_equip_label_series: "Serie",
  admin_add_equip_label_ca: "CA",
  admin_add_equip_label_obs_tech: "Observación Técnica",
  admin_add_equip_label_location: "Localización",
  admin_add_equip_label_next_revision: "Próxima Revisión",
  admin_add_equip_label_last_revision: "Última Revisão",
  admin_add_equip_label_active: "Activo",
  admin_add_equip_btn_back: "Volver",
  admin_add_equip_btn_save: "Guardar",
  admin_add_equip_btn_add_photo_before: "Añadir Foto Antes",
  admin_add_equip_btn_add_photo_after: "Añadir Foto Después",
  admin_add_equip_btn_send_laudo: "Enviar Informe (PDF)",
  admin_add_equip_btn_close: "Cerrar",
  admin_add_equip_card_title_data: "📌 Datos del Equipo",
  admin_add_equip_card_title_photos: "📷 Fotos",
  admin_add_equip_card_title_laudos: "📑 Informes",
  admin_details_error_no_quotation: "Ninguna cotización seleccionada",
  admin_details_error_loading_details: "Error al cargar detalles. Usando datos de demostración.",
  admin_details_not_informed_company: "Empresa no informada",
  admin_details_not_informed_client: "Cliente no informado",
  admin_details_not_informed_address: "Dirección no informada",
  admin_details_not_specified_service: "Servicio no especificado",
  admin_details_no_observations: "Sin observaciones",
  admin_details_status_received_analysis: "Equipo recibido y en análisis.",
  admin_details_swal_confirm_receive_title: "¿Confirmar recepción?",
  admin_details_swal_confirm_receive_text: "Esto indica al cliente la recepción e indica que el equipo será analizado.",
  admin_details_swal_confirm_button: "Sí, confirmar",
  admin_details_swal_cancel_button: "Cancelar",
  admin_details_swal_success_title: "Éxito",
  admin_details_swal_update_success_text: "Estimación actualizada a 'equipo en análisis'.",
  admin_details_swal_error_title: "Error",
  admin_details_swal_update_error_text: "No fue posible actualizar la estimación.",
  admin_details_loading_text: "Cargando detalles...",
  admin_details_card_title_client: "📌 DATOS DEL CLIENTE",
  admin_details_card_title_estimate: "📋 DATOS DE LA ESTIMACIÓN",
  admin_details_card_title_budget: "💰 DATOS DEL PRESUPUESTO",
  admin_details_no_data_available: "No hay datos disponibles para mostrar.",
  admin_equip_details_error_id_not_found: "ID del equipo no encontrado",
  admin_equip_details_loading_text: "Cargando...",
  admin_equip_details_error_not_found: "Equipo no encontrado",
  admin_equip_details_title_item_data: "Datos del Ítem",
  admin_equip_details_title_latest_photos: "Últimas Fotos del Equipo",
  admin_equip_details_title_revision_history: "Historial de Revisiones",
  admin_equipaments_title_my_equipments: "Mis Equipos",
  admin_equipaments_btn_add_equipment: "Añadir Equipo",
  admin_estimate_respond_swal_attention_title: "Atención",
  admin_estimate_respond_swal_no_items_text: "Añada al menos un ítem a la respuesta",
  admin_estimate_respond_swal_success_title: "Éxito",
  admin_estimate_respond_swal_sent_text: "¡Respuesta enviada!",
  admin_estimate_respond_swal_error_title: "Error",
  admin_estimate_respond_swal_error_text: "No fue posible enviar la respuesta",
  admin_estimate_respond_created_by_admin: "creado por: Comercial",
  admin_estimate_respond_card_title_client: "📌 DATOS DEL CLIENTE",
  admin_estimate_respond_card_title_estimate: "📋 DATOS DE LA ESTIMACIÓN",
  admin_estimate_respond_card_title_admin_response: "✍️ RESPUESTA DEL COMERCIAL",
  admin_home_error_loading_details: "Error al cargar datos. Usando datos de demostración.",
  admin_home_swal_search_title: "Buscar Equipo",
  admin_home_swal_search_label: "Ingrese el ID del equipo:",
  admin_home_swal_search_btn_confirm: "Buscar",
  admin_home_swal_search_btn_cancel: "Cancelar",
  admin_home_swal_found_title: "Equipo Encontrado",
  admin_home_swal_not_found_title: "Equipo no localizado",
  admin_home_card_label_waiting_estimate: "Esperando\nEstimación",
  admin_home_card_label_estimate_delivered: "Estimación\nEntregada",
  admin_home_card_label_waiting_equipment: "Esperando\nEquipo",
  admin_home_card_label_equipment_analysis: "Equipo\nEn Análisis",
  admin_home_card_label_waiting_budget: "Esperando\nPresupuesto",
  admin_home_card_label_pending_approval: "Pendiente de\nAprobación",
  admin_home_card_label_approved_maintenance: "Aprobado para\nMantenimiento",
  admin_home_card_label_waiting_inspection: "Esperando\nInspección e Informe",
  admin_home_card_label_waiting_nf: "Esperando\nFacturación",
  admin_home_card_label_ready_pickup: "Listo para\nRetiro",
  admin_home_loading_text: "Cargando datos...",
  admin_home_status_desc_waiting_estimate: "El cliente solicitó una estimación.",
  admin_home_status_desc_estimate_delivered: "La estimación fue respondida, el cliente debe recibirla pronto.",
  admin_home_status_desc_waiting_equipment: "El cliente aceptó la estimación, y estamos esperando el envío del equipo.",
  admin_home_status_desc_equipment_analysis: "El equipo llegó y está en análisis/registro.",
  admin_home_status_desc_waiting_budget: "Se realizó el análisis, falta la liberación del administrador.",
  admin_home_status_desc_pending_approval: "El cliente aún no ha aprobado el presupuesto.",
  admin_home_status_desc_approved_maintenance: "El cliente aprobó y debe haber enviado la orden de compra.",
  admin_home_status_desc_waiting_inspection: "Realice la inspección final y cargue el informe del equipo.",
  admin_home_status_desc_waiting_nf: "Realice la facturación del cliente.",
  admin_home_status_desc_ready_pickup: "El equipo está listo, esperando que el cliente lo retire para dar de baja.",
  admin_home_last_update_text: "Última actualización: ",
  admin_home_table_header_created: "Creado",
  admin_home_table_header_type: "Tipo",
  admin_home_table_header_code: "Código",
  admin_home_table_header_cnpj: "CNPJ/CIF",
  admin_home_table_header_client: "Cliente",
  admin_home_table_header_value: "Valor $",
  admin_home_table_footer_total: "TOTAL",
  admin_home_btn_register: "Registrar",
  admin_home_btn_register_client: "Registrar Cliente",
  admin_home_btn_search: "Pesquisar",
  admin_home_search_cnpj_nota_label: "Buscar por CNPJ o numero de nota",
  admin_home_search_cnpj_nota_placeholder: "Ingrese el CNPJ o numero de nota",
  admin_home_search_note_pending_msg: "La busqueda por CNPJ esta activa. La busqueda por nota se habilitara tras la actualizacion del backend en Home.",
  admin_home_btn_search_equipment: "Buscar Equipo",
  admin_home_btn_clients: "Clientes",
  admin_home_btn_reports: "Reportes",
  admin_home_panel_title_phases: "Fases de la Operación",
  admin_home_panel_label_responsible: "Responsable:",
  admin_home_panel_label_admin: "Comercial",
  admin_home_panel_label_client: "Cliente",
  admin_home_panel_label_workshop: "Taller",
  admin_quotations_swal_attention_title: "Atención",
  admin_quotations_swal_new_appointment_warning: "Al proceder, generará un nuevo registro sin vínculo con ninguna estimación. ¿Está seguro de que desea continuar? (para generar un registro vinculado, hágalo desde los detalles de la estimación)",
  admin_quotations_swal_confirm_continue: "Sí, continuar",
  admin_quotations_swal_cancel: "Cancelar",
  admin_quotations_swal_new_appointment_title: "Nuevo Registro",
  admin_quotations_swal_creating_appointment_text: "Creando nuevo registro...",
  admin_quotations_loading_text: "Cargando...",
  admin_quotations_page_title: "Cotizaciones",
  admin_quotations_label_client: "Cliente: ",
  admin_quotations_btn_create_appointment: "Crear Registro",
  admin_quotations_btn_equipments: "Equipos",
  admin_quotations_section_title_pending: "Pendiente Conmigo",
  admin_quotations_empty_message_pending: "Ningún registro pendiente",
  admin_quotations_section_title_in_progress: "En Curso",
  admin_quotations_empty_message_in_progress: "Ningún registro en curso",
  admin_quotations_section_title_finished: "Finalizados",
  admin_quotations_empty_message_finished: "Ningún registro finalizado",
  admin_quote_swal_attention_title: "Atención",
  admin_quote_swal_equipment_already_added: "Equipo ya añadido al presupuesto",
  admin_quote_swal_remove_equipment_title: "¿Eliminar equipo?",
  admin_quote_swal_yes: "Sí",
  admin_quote_swal_no: "No",
  admin_quote_swal_no_service_linked: "Este equipo no tiene servicio vinculado",
  admin_quote_swal_error_title: "Error",
  admin_quote_swal_service_not_found: "Servicio no encontrado",
  admin_quote_swal_remove_item_title: "¿Eliminar ítem?",
  admin_quote_swal_success_title: "Éxito",
  admin_quote_swal_attachment_sent: "¡Anexo enviado con éxito!",
  admin_quote_swal_add_nf_title: "Añadir Factura",
  admin_quote_swal_nf_name_placeholder: "Nombre de la factura",
  admin_quote_swal_select_file: "Seleccionar Archivo",
  admin_quote_swal_cancel: "Cancelar",
  admin_quote_swal_validation_nf: "Complete el nombre y la fecha de la factura",
  admin_quote_swal_nf_sent: "¡Factura enviada!",
  admin_quote_swal_remove_attachment_title: "¿Eliminar anexo?",
  admin_quote_swal_action_undone_text: "Esta acción no se puede deshacer.",
  admin_quote_swal_confirm_remove: "Sí, eliminar",
  admin_quote_swal_attachment_removed: "Anexo eliminado con éxito",
  admin_quote_swal_remove_nf_title: "¿Eliminar factura?",
  admin_quote_swal_nf_removed: "Factura eliminada con éxito",
  admin_quote_swal_no_equipments_error: "Añada al menos un equipo al presupuesto",
  admin_quote_swal_generate_quote_title: "Generar Presupuesto",
  admin_quote_swal_generate_quote_text: "Esto generará un presupuesto para aprobación administrativa.\n\nAsegúrese de haber incluido todas las piezas y procedimientos del servicio.\n\n¿Desea continuar?",
  admin_quote_swal_generate_quote_confirm: "Sí, generar presupuesto",
  admin_quote_swal_quote_saved_success: "¡Presupuesto guardado con éxito!",
  admin_quote_swal_save_error: "No fue posible guardar el presupuesto",
  admin_search_placeholder_company_cnpj: "empresa o cnpj/cif",
  admin_search_placeholder_quotation_num: "nº cotización",
  admin_search_msg_initial: "🔎 Ingrese lo que desea buscar",
  admin_search_title_companies_found: "Empresas Encontradas",
  admin_search_msg_no_companies: "Ninguna empresa encontrada",
  admin_search_title_quotations_found: "Cotizaciones Encontradas",
  admin_search_msg_no_quotations: "Ninguna cotización encontrada",
  admin_search_label_company: "Empresa:",
  admin_search_label_email: "Email:",
  admin_search_label_phone: "Tel:",
  admin_search_label_cnpj: "CNPJ/CIF:",
  admin_search_label_doc_num: "Núm.Doc:",
  admin_search_label_type: "Tipo:",
  admin_search_label_date: "Fecha:",
  admin_search_btn_view_equipments: "Ver Equipos",
  admin_search_btn_view: "Visualizar",
  admin_shipment_title_main: "📦 Instrucciones de Envío",
  admin_shipment_title_order_data: "Datos del Pedido",
  admin_shipment_title_sender: "Remitente",
  admin_shipment_title_shipping_address: "Dirección de Envío",
  admin_shipment_title_general_instructions: "Instrucciones Generales",
  admin_shipment_msg_important_print: "Importante: Imprima este documento y adjúntelo con el equipo. Si no puede imprimir, escriba el número de pedido y su CNPJ/CIF en el embalaje de forma visible.",
  admin_shipment_label_estimate_num: "Estimación nº: ",
  admin_shipment_label_cnpj: "CNPJ/CIF: ",
  admin_shipment_label_client: "Cliente:",
  admin_shipment_label_company: "Empresa:",
  admin_shipment_label_phone: "Teléfono:",
  admin_shipment_label_email: "E-mail:",
  admin_shipment_address_company_name: "Bepi Service",
  admin_shipment_address_street: "Estrada Velha Guarulhos São Miguel, 5135",
  admin_shipment_address_city_zip: "Jardim Arapongas, Guarulhos - SP, 07210-250",
  admin_shipment_instruction_1: "Embalar el equipo de forma segura para evitar daños.",
  admin_shipment_instruction_2: "Incluir todos los accesorios obligatorios para el servicio solicitado.",
  admin_shipment_instruction_3: "Identificar cada ítem si hay más de uno por bulto.",
  admin_shipment_instruction_4: "Enviar solo equipos aprobados. Los rechazados no deben ser enviados.",
  admin_shipment_instruction_5: "No cobramos recolección. El envío corre por cuenta del cliente.",
  admin_shipment_instruction_6: "La factura de envío debe ser correcta. En caso de error, la devolución será por flete FOB.",
  admin_shipment_msg_warning_nf: "⚠️ Si la factura se emite de forma incorrecta, el equipo será devuelto por flete FOB.",
  admin_shipment_msg_warning_missing_data: "💡 La falta del número de pedido o del CNPJ/CIF puede retrasar el inicio de su atención.",
  admin_shipment_footer_technical_service: "BEPI SERVICE - Soporte técnico",
  admin_shipment_footer_whatsapp: "En caso de dudas, contáctenos por WhatsApp: (11) 91234-5678",
  admin_shipment_btn_back_home: "Volver al Inicio",
  admin_shipment_btn_print: "Imprimir Instrucciones",
  admin_breadcrumb_quotations: "Cotizaciones",
  admin_breadcrumb_quote: "Presupuesto",
  admin_breadcrumb_estimate_respond: "Respuesta de estimación",
  admin_breadcrumb_search: "Buscar",
  admin_breadcrumb_add_equipment: "Agregar equipo",
  admin_breadcrumb_shipment: "Instrucciones de envío",
  admin_home_card_label_sent: "Enviado",
  admin_home_status_desc_sent: "El material fue enviado y ya no esta en el taller esperando retiro. Proceso cerrado.",
  admin_home_table_header_actions: "Acciones",
  admin_home_mark_sent_btn: "Marcar como Enviado",
  admin_home_mark_sent_confirm_title: "Confirmar",
  admin_home_mark_sent_confirm_text: "Desea avanzar este item a Enviado?",
  admin_home_mark_sent_success: "Estado actualizado a Enviado.",
  admin_home_mark_sent_error: "No fue posible actualizar el estado a Enviado.",
  admin_home_card_label_authorize_maintenance: "Autorizar\nMantenimiento",
  admin_home_status_desc_authorize_maintenance: "Validar si el cliente envio toda la informacion necesaria para iniciar el mantenimiento.",
  admin_home_authorize_maintenance_btn: "Autorizar Mantenimiento",
  admin_home_authorize_maintenance_confirm_title: "Confirmar",
  admin_home_authorize_maintenance_confirm_text: "Desea avanzar este item a Autorizar Mantenimiento?",
  admin_home_authorize_maintenance_success: "Estado actualizado a Autorizar Mantenimiento.",
  admin_home_authorize_maintenance_error: "No fue posible actualizar el estado a Autorizar Mantenimiento.",
  admin_home_approve_maintenance_btn: "Aprobar para Mantenimiento",
  admin_home_approve_maintenance_confirm_title: "Confirmar",
  admin_home_approve_maintenance_confirm_text: "Desea avanzar este item a Aprobado para Mantenimiento?",
  admin_home_approve_maintenance_success: "Estado actualizado a Aprobado para Mantenimiento.",
  admin_home_approve_maintenance_error: "No fue posible actualizar el estado a Aprobado para Mantenimiento.",
  admin_home_card_label_finalized: "Finalizado",
  admin_home_status_desc_finalized: "Flujo finalizado manualmente por el equipo comercial.",
  admin_details_finalize_flow_btn: "Finalizar Operación",
  admin_details_finalize_flow_confirm_title: "Confirmar",
  admin_details_finalize_flow_confirm_text: "¿Desea finalizar el flujo de esta cotización?",
  admin_details_finalize_flow_success: "Flujo finalizado con éxito.",
  admin_details_finalize_flow_error: "No fue posible finalizar el flujo.",
}
